
<mat-sidenav-container fullscreen id="container">

  <!-- SideNav drawer (hidden Menu side)  -->
  <mat-sidenav #drawer [(opened)]="display" class="alignCenter" mode="side">
    <mat-nav-list>
      <!--     List ov navegating options for menu  -->
      <mat-list-item (click)="visible(item.name)" *ngFor="let item of navItem" class="listItem">
        <h4 id="h4" ><span class="effect-underline">{{item.name}}</span></h4>
      </mat-list-item>
    </mat-nav-list>
  </mat-sidenav>

  <!--PAGE MAIN CONTENT -->
  <mat-sidenav-content class="ui-sidebar" [class.applyBorder]="!display">
    <!--  Menu Button  -->
    <button (click)="display=!display"  id="menu" pButton>
      <i *ngIf="!display"  class="fa fa-bars" style="font-size:20px" ></i>
      <!--  When menu is open    -->
      <!--  x = fa fa-caret-logo     -->
      <!--  When menu is closed  -->
      <i *ngIf="display" aria-hidden="true" class="fa fa-caret-left" style="font-size:20px" id="caret"></i>
      <span *ngIf="!display"> </span>
    </button>

    <!--  Router  for access to other Components  -->
    <div class="routerContainer">
      <router-outlet></router-outlet>
    </div>

  </mat-sidenav-content>

</mat-sidenav-container>





